<template>
    <v-text-field
        v-model="color"
        v-bind="attrs"
        v-on="listeners"
    >
        <template v-slot:append>
            <v-menu :disabled="attrs.disabled" v-model="isShowMenu" offset-y :close-on-content-click="false">
                <template v-slot:activator="{ on }">
                    <v-sheet
                        v-on="on"
                        :color="pickerColor"
                        elevation="2"
                        height="20"
                        width="20"
                        :style="{cursor: attrs.disabled ? 'default' : 'pointer'}"
                        :disabled="attrs.disabled"
                    ></v-sheet>
                </template>
                <v-color-picker
                    v-if="isShowMenu"
                    v-model="pickerColor"
                    :modes="['rgba']"
                    show-swatches
                    :disabled="attrs.disabled"
                ></v-color-picker>
            </v-menu>
        </template>
    </v-text-field> 
</template>

<script>

import _ from "lodash";
import ColorHelper from "@/mixins/ColorHelper.js";

export default {
    name: 'VTextFieldColorPicker',
    props: {
        value: String
    },
    mixins: [ColorHelper],
    data: () => ({
        isShowMenu: false,
    }),
    computed: {
        color: {
            get() {
                return this.value;
            },
            set(v) {
                this.$emit('input', v);
            }
        },
        hexColor() {
            return this.color && this.COLORS[this.color.toLowerCase()] || this.color;
        },
        pickerColor: {
            get() {
                return this.hexColor;
            },
            set(v) {
                const name = _.findKey(this.COLORS, c => (c.toLowerCase() === v.toLowerCase()) || ((c.toLowerCase() + 'ff') === v.toLowerCase()));
                this.color = name || v;
            }
        },
        attrs() {
            return _.omit(this.$attrs, []);
        },
        listeners() {
            return _.omit(this.$listeners, []);
        },
    },
    methods: {
    }
}
</script>
<style scoped lang="scss">
    .v-application--is-ltr .v-text-field ::v-deep .v-input__append-inner {
        margin-right: 3px;
    }
</style>